import { useEffect } from 'react';
import { useLocationParams } from 'hooks';

/**
 * Drops creatives / campaigns / ad sets / step (and the rest) from the URL
 * once the create-ads job result table is on screen, so a refresh cannot
 * restore the finished session.
 */
const useClearLocationParamsOnJobResult = (
  isJobStatusFinished: boolean
): void => {
  const { resetLocationParamsToStart } = useLocationParams();

  useEffect(() => {
    if (!isJobStatusFinished) return;
    resetLocationParamsToStart();
  }, [isJobStatusFinished, resetLocationParamsToStart]);
};

export default useClearLocationParamsOnJobResult;
